/*
* Continuous conditions
*
*/
import {monthsIndexed} from "../../../util";

export const ContinuousConditions = (typeFieldName) => {
  const today = new Date();

  return {
    type: 'field-group',
    name: 'continuousCriteria',
    condition: {
      action: 'show', condition: {[typeFieldName]: {'_eq': 'continuous'}}
    },
    fields: [{
        type: 'number',
        name: 'from_year',
        label: 'From Year',
        minValue: 2000,
      }, {
        type: 'select',
        name: 'from_month',
        label: 'Month',
        choices: monthsIndexed,
      }, {
        type: 'number',
        name: 'from_day',
        label: 'Day', minValue: 1,
        maxValue: 31,

      },
    ],
  }
}
